import React from 'react';
import { useNavigate } from 'react-router-dom';
import arrowLeft from '../../assets/images/arrow-left.svg';

interface TitleHeaderProps {
  title: string;
  prevRoute?: string;
  showPrevIcon?: boolean;
  /**
   * Custom back handler for multi-step flows
   * When provided, this will be called instead of default navigation
   * Should return true if the handler handled the back action (e.g., went to previous step)
   * Should return false if navigation should proceed with default behavior (e.g., navigate back)
   */
  onBackClick?: () => boolean;
}

const TitleHeader: React.FC<TitleHeaderProps> = ({ title, prevRoute, showPrevIcon = true, onBackClick }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    // If there's a custom back handler, call it first
    if (onBackClick) {
      // If handler returns true, it handled the back action
      // If false, proceed with default navigation
      const handled = onBackClick();
      if (handled) {
        return;
      }
    }
    
    // Default navigation behavior
    if (prevRoute) {
      // Navigate to explicit route if provided
      navigate(prevRoute, { replace: false });
    } else {
      // Use React Router's navigate(-1) to go back
      // This preserves the React Router history stack and prevents page reload
      navigate(-1);
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 h-[70px] flex items-center px-4 z-50 bg-white">
      {showPrevIcon && <button 
        onClick={handleBack} 
        className="p-2 hover:opacity-70"
      >
        <img src={arrowLeft} alt="Back" className="w-6 h-6" />
      </button>}
      <h1 className="text-lg font-bold flex-1 text-center mr-8">{title}</h1>
    </div>
  );
};

export default TitleHeader;
